module.exports = __webpack_public_path__ + "static/media/exit-screen.c3c51065.svg";